import { EVENT_TYPES } from "nemuru-components";
import React, { useContext, useState } from "react";
import { ProcessContext } from "../../../../contexts/ProcessContext";
import { useActionCallback } from "../../../../utils/hooks/useActionCallback";
import { useEventDispatcher } from "../../../../utils/hooks/useEventDispatcher";
import { FLOW_MESSAGES } from "../../../shared/components/flowMessages/components";
import IncomeTypeToggle from "../shared/components/IncomeTypeToggle";
import { BankReaderFactory } from "./components/BankReaderFactory/BankReaderFactory";

const VISIBLE_COMPONENT = {
  INCOME_TYPE: "INCOME_TYPE",
  BANK_READER_FACTORY: "BANK_READER_FACTORY",
};

export default function BankReader(props) {
  const {
    state: { currentModuleObject },
    dispatch,
  } = useContext(ProcessContext);
  const { dispatchEvent } = useEventDispatcher();

  const [visibleComponent, setVisibleComponent] = useState(
    VISIBLE_COMPONENT.INCOME_TYPE
  );

  const { disableIncomeTypeToggleDescription: disableIncomeToggle } = props;

  useActionCallback(
    "REQUEST_POST_ADD_CASH_IN_CASH_OUT_METHOD_EUROBITS_FULFILLED",
    () => {
      setItemStepOkAndSendOkMessage();
    }
  );

  const setItemStepOkAndSendOkMessage = () => {
    dispatch({
      type: "SET_FLOW_ITEM_OK",
    });
    dispatch({
      type: "SET_FLOW_LOADING",
      payload: { show: false },
    });
    dispatch({
      type: "SET_FLOW_MESSAGE",
      payload: { id: FLOW_MESSAGES.SEND_OK.id },
    });
  };

  const navigateToBankReader = () => {
    const screenPath = `${currentModuleObject?.id}.EUROBITS_WIDGET`;
    dispatchEvent({
      name: screenPath,
      type: EVENT_TYPES.progress,
      payload: {
        module: currentModuleObject?.id,
        screenPath: screenPath,
      },
    });
    setVisibleComponent(VISIBLE_COMPONENT.BANK_READER_FACTORY);
  };

  const navigateToIncomeTypeToggle = () =>
    setVisibleComponent(VISIBLE_COMPONENT.INCOME_TYPE);

  return (
    <>
      {visibleComponent === VISIBLE_COMPONENT.INCOME_TYPE && (
        <IncomeTypeToggle
          onNext={navigateToBankReader}
          disableIncomeToggle={disableIncomeToggle}
        />
      )}
      {visibleComponent === VISIBLE_COMPONENT.BANK_READER_FACTORY && (
        <BankReaderFactory onPrev={navigateToIncomeTypeToggle} />
      )}
    </>
  );
}
